import type { Extensions } from '@tiptap/react';

import Emoji from '@tiptap/extension-emoji';
import { TableKit } from '@tiptap/extension-table';

import { simpleExtensionSet } from '.';

export const postExtensionSet: Extensions = [
  ...simpleExtensionSet,
  TableKit.configure({
    table: { resizable: true },
  }),
  Emoji.configure({
    enableEmoticons: true,
  }),
];
